module.exports = __webpack_public_path__ + "img/wbzf.a175dff6.png";